import React from "react";
import { Link } from "react-router-dom";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import {
  faKey,
  faCogs,
  faUsersCog,
  faWeight,
  faCalendarCheck,
  faUser,
  faUsers,
  faSignOutAlt,
  faTachometerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDispatch, useSelector } from "react-redux";

import UserAvatar from "../../assets/img/user-avatar.png";
import SayalLogo from "../../assets/img/sayal-logo.png";
import {
  AccountTree,
  Category,
  AttachMoney,
  Speed,
  Receipt,
  EventNote,
  Contactless,
} from "@material-ui/icons";
import AssessmentIcon from "@material-ui/icons/Assessment";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import { setUserInfo } from "../../utils/UserInfo";
import { useHistory } from "react-router-dom";
import { BLACK, HOST, WHITE } from "../../utils/const";
import { SetAdminProfile, SetUserInfo } from "../../store/actions";
import HomeIcon from "@material-ui/icons/Home";

const SideBar = (props) => {
  const profile = useSelector((state) => state.adminProfile);
  const user = useSelector((state) => state.user);

  // const username = settings.user.name.length > 0 ? settings.user.name + " " + settings.user.lastName : settings.user.username
  const username = profile.admin_name + " " + profile.admin_lastname;
  // const restName = settings.restInfo.restName
  const complexName = "شرکت سیال سنجش";

  const history = useHistory();
  const dispatch = useDispatch();

  const logout = () => {
    setUserInfo({});
    dispatch(SetAdminProfile({}));
    dispatch(SetUserInfo({ token: "", permissions: [] }));
    history.push("/admin/login");
  };

  const fileResult = profile.other_information
    ? profile.other_information.file_result
    : undefined;
  const avatar =
    fileResult == undefined ? UserAvatar : HOST + fileResult.fileurl;

  const itemColor = WHITE; // #e7e7e7
  const headerColor = WHITE; // white
  const bgColor = "#00b3b3"; // #34495e
  const itemFontWeight = "bold";
  const darkColor = "#333333";

  const renderGeneralPossibilitiesLabel = () => {
    return (
      <MenuItem
        style={{
          fontWeight: "bold",
          color: darkColor,
          backgroundColor: WHITE,
        }}
        icon={<FontAwesomeIcon style={{ fontSize: "20px" }} icon={faKey} />}
      >
        امکانات عمومی
      </MenuItem>
    );
  };

  const renderDashboard = () => {
    if (user.permissions.includes("Base")) {
      return (
        <MenuItem
          icon={
            // <FontAwesomeIcon
            //   style={{ fontSize: "20px", color: itemColor }}
            //   icon={faTachometerAlt}
            // />
            <HomeIcon style={{ fontSize: "24px", color: itemColor }} />
          }
        >
          <Link
            style={{ color: itemColor, fontWeight: itemFontWeight }}
            to={"/admin"}
          >
            داشبورد
          </Link>
        </MenuItem>
      );
    } else {
      return null;
    }
  };

  const renderProjectManagement = () => {
    return (
      <SubMenu
        style={{ backgroundColor: bgColor }}
        title={
          <span style={{ color: itemColor, fontWeight: itemFontWeight }}>
            مدیریت پروژه ها
          </span>
        }
        icon={
          <FontAwesomeIcon
            style={{ fontSize: "20px", color: itemColor }}
            icon={faCogs}
          />
        }
      >
        <MenuItem
          icon={<AccountTree style={{ fontSize: "24px", color: itemColor }} />}
        >
          <Link
            style={{ color: itemColor, fontWeight: itemFontWeight }}
            to="/admin/add-project"
          >
            افزودن پروژه
          </Link>
        </MenuItem>
        <MenuItem
          icon={<AccountTree style={{ fontSize: "24px", color: itemColor }} />}
        >
          <Link
            style={{ color: itemColor, fontWeight: itemFontWeight }}
            to="/admin/projects"
          >
            مشاهده پروژه ها
          </Link>
        </MenuItem>
      </SubMenu>
    );
  };
  const renderBillsManagement = () => {
    return (
      <SubMenu
        style={{ backgroundColor: bgColor }}
        title={
          <span style={{ color: itemColor, fontWeight: itemFontWeight }}>
            مدیریت قبوض
          </span>
        }
        icon={
          <FontAwesomeIcon
            style={{ fontSize: "20px", color: itemColor }}
            icon={faCogs}
          />
        }
      >
        <MenuItem
          icon={<AccountTree style={{ fontSize: "24px", color: itemColor }} />}
        >
          <Link
            style={{ color: itemColor, fontWeight: itemFontWeight }}
            to="/admin/show-bills"
          >
            مشاهده قبض
          </Link>
        </MenuItem>
        <MenuItem
          icon={<Receipt style={{ fontSize: "24px", color: itemColor }} />}
        >
          <Link
            style={{ color: itemColor, fontWeight: itemFontWeight }}
            to="/admin/create-bills"
          >
            صدور قبض
          </Link>
        </MenuItem>
      </SubMenu>
    );
  };
  const renderCounterManagement = () => {
    if (user.permissions.includes("Base")) {
      return (
        <SubMenu
          style={{ backgroundColor: bgColor }}
          title={
            <span style={{ color: itemColor, fontWeight: itemFontWeight }}>
              مدیریت کنتورها
            </span>
          }
          icon={
            <FontAwesomeIcon
              style={{ fontSize: "20px", color: itemColor }}
              icon={faCogs}
            />
          }
        >
          <MenuItem
            icon={<Category style={{ fontSize: "24px", color: itemColor }} />}
          >
            <Link
              style={{ color: itemColor, fontWeight: itemFontWeight }}
              to="/admin/counter-tags"
            >
              دسته بندی ها
            </Link>
          </MenuItem>
          <MenuItem
            icon={<Category style={{ fontSize: "24px", color: itemColor }} />}
          >
            <Link
              style={{ color: itemColor, fontWeight: itemFontWeight }}
              to="/admin/counter-types"
            >
              انواع کنتورها
            </Link>
          </MenuItem>

          <MenuItem
            icon={<Speed style={{ fontSize: "24px", color: itemColor }} />}
          >
            <Link
              style={{ color: itemColor, fontWeight: itemFontWeight }}
              to="/admin/counters"
            >
              کنتورها
            </Link>
          </MenuItem>

          <MenuItem
            icon={
              <AttachMoney style={{ fontSize: "24px", color: itemColor }} />
            }
          >
            <Link
              style={{ color: itemColor, fontWeight: itemFontWeight }}
              to="/admin/modules"
            >
              ماژول هوشمند
            </Link>
          </MenuItem>
        </SubMenu>
      );
    } else {
      return null;
    }
  };

  const renderUserManagement = () => {
    return (
      <MenuItem
        icon={
          <FontAwesomeIcon
            style={{ fontSize: "20px", color: itemColor }}
            icon={faUsersCog}
          />
        }
      >
        <Link
          style={{ color: itemColor, fontWeight: itemFontWeight }}
          to="/admin/users-management"
        >
          مدیریت کاربران
        </Link>
      </MenuItem>
    );
  };

  const renderReportsLabel = () => {
    if (user.permissions.includes("Base")) {
      return (
        <MenuItem
          style={{
            fontWeight: "bold",
            color: darkColor,
            backgroundColor: WHITE,
          }}
          icon={
            <FontAwesomeIcon
              style={{ fontSize: "20px", color: darkColor }}
              icon={faUsers}
            />
          }
        >
          گزارشات
        </MenuItem>
      );
    } else {
      return null;
    }
  };

  const renderSystemReports = () => {
    if (user.permissions.includes("Base")) {
      return (
        <>
          <MenuItem
            icon={
              <AssessmentIcon style={{ fontSize: "24px", color: itemColor }} />
            }
          >
            <Link
              style={{ color: itemColor, fontWeight: itemFontWeight }}
              to="/admin/reports"
            >
              گزارشات سیستم
            </Link>
          </MenuItem>
          <MenuItem
            icon={
              <EventNote style={{ fontSize: "24px", color: itemColor }} />
              // <EventNoteIcon style={{ fontSize: "24px", color: itemColor }} />
            }
          >
            <Link
              style={{ color: itemColor, fontWeight: itemFontWeight }}
              to="/admin/events"
            >
              مدیریت رویدادها
            </Link>
          </MenuItem>
          <MenuItem
            icon={
              <Contactless style={{ fontSize: "24px", color: itemColor }} />
            }
          >
            <Link
              style={{ color: itemColor, fontWeight: itemFontWeight }}
              to="/admin/orders"
            >
              مدیریت دستورات
            </Link>
          </MenuItem>
        </>
      );
    } else {
      return null;
    }
  };

  const renderUserAreaLabel = () => {
    return (
      <MenuItem
        style={{
          fontWeight: "bold",
          color: darkColor,
          backgroundColor: WHITE,
        }}
        icon={
          <FontAwesomeIcon
            style={{ fontSize: "20px", color: darkColor }}
            icon={faUsers}
          />
        }
      >
        ناحیه کاربری
      </MenuItem>
    );
  };

  const renderAccessabilityManagement = () => {
    if (user.permissions.includes("Base")) {
      return (
        <MenuItem
          icon={
            <AccessibilityIcon style={{ fontSize: "24px", color: itemColor }} />
          }
        >
          <Link
            style={{ color: itemColor, fontWeight: itemFontWeight }}
            to="/admin/accessability"
          >
            مدیریت دسترسی به پنل
          </Link>
        </MenuItem>
      );
    } else {
      return null;
    }
  };

  const renderChangeUserInfo = () => {
    return (
      <MenuItem
        icon={
          <FontAwesomeIcon
            style={{ fontSize: "20px", color: itemColor }}
            icon={faUser}
          />
        }
      >
        <Link
          style={{ color: itemColor, fontWeight: itemFontWeight }}
          to="/admin/profile"
        >
          تغییر نام کاربری و رمز عبور
        </Link>
      </MenuItem>
    );
  };

  const renderLogout = () => {
    return (
      <MenuItem
        onClick={logout}
        icon={
          <FontAwesomeIcon
            style={{ fontSize: "20px", color: itemColor }}
            icon={faSignOutAlt}
          />
        }
      >
        <Link style={{ color: itemColor, fontWeight: itemFontWeight }} to="#">
          خروج
        </Link>
      </MenuItem>
    );
  };

  return (
    <ProSidebar
      onToggle={props.onToggle}
      toggled={props.toggled}
      breakPoint={"lg"}
      collapsed={props.collapse}
      rtl={true}
    >
      <SidebarHeader style={{ backgroundColor: bgColor }}>
        <MenuItem
          style={{
            textAlign: "center",
            color: "#333333",
            fontSize: "18px",
          }}
        >
          <div
            style={{
              width: "70px",
              height: "70px",
              marginRight: "auto",
              marginLeft: "auto",
            }}
          >
            <img
              src={SayalLogo}
              style={{ width: "100%", borderRadius: "8px" }}
              alt="complex-logo"
            />
          </div>
          <div
            style={{
              backgroundColor: "#fff",
              paddingTop: "8px",
              paddingBottom: "8px",
              fontWeight: itemFontWeight,
            }}
          >
            {complexName}
          </div>
        </MenuItem>
      </SidebarHeader>
      <SidebarContent
        style={{ backgroundColor: bgColor, paddingBottom: "16px" }}
      >
        <Menu>
          <MenuItem
            style={{ borderBottom: "1px solid white", paddingBottom: "8px" }}
            icon={
              <img
                style={{ borderRadius: "50%", border: "4px solid white" }}
                src={avatar}
                width="45px"
                height="45px"
                alt="User-Avatar"
              />
            }
          >
            <Link style={{ color: "#e7e7e7" }} to={"/admin/profile"}>
              <span
                style={{
                  fontSize: "18px",
                  marginRight: "24px",
                  color: itemColor,
                  fontWeight: itemFontWeight,
                }}
              >
                {username}
              </span>
            </Link>
          </MenuItem>

          {renderGeneralPossibilitiesLabel()}

          {renderDashboard()}

          {renderProjectManagement()}

          {renderCounterManagement()}

          {renderBillsManagement()}

          {renderUserManagement()}

          {renderReportsLabel()}

          {renderSystemReports()}

          {renderUserAreaLabel()}

          {renderAccessabilityManagement()}

          {renderChangeUserInfo()}

          {renderLogout()}
        </Menu>
      </SidebarContent>

      <SidebarFooter style={{ backgroundColor: "#34495e" }}></SidebarFooter>
    </ProSidebar>
  );
};

export default SideBar;
